import styled from 'styled-components';
export const Wrapper = styled.div `
  margin-top: 8px;
  margin-right: -46px;
  margin-left: -46px;
`;
export const RightContent = styled.div `
  text-align: right;
`;
